import {
  FastArrowLeft,
  FastArrowRight,
  NavArrowLeft,
  NavArrowRight,
} from 'iconoir-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';

export const toolsPaginationButtonClassName =
  'h-8 w-8 rounded-full border border-[#e7e7e7] bg-white p-0 text-[#3d3d3d] shadow-none hover:bg-white hover:text-[#3d3d3d] disabled:border-[#e7e7e7] disabled:bg-white disabled:text-[#c4c4c4] dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-card dark:disabled:border-border dark:disabled:bg-card dark:disabled:text-muted-foreground';

type ToolsPaginationProps = {
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
};

export function ToolsPagination({ page, pageCount, onPageChange }: ToolsPaginationProps) {
  const { t } = useTranslation();

  return (
    <div className="mt-6 flex w-full items-center justify-end gap-4">
      <p className="text-sm font-normal leading-[1.2] text-[#3d3d3d] dark:text-foreground">
        {t('PAGE_OF', {
          page,
          total: pageCount,
          defaultValue: `Page ${page} of ${pageCount}`,
        })}
      </p>

      <div className="flex items-center gap-1">
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={toolsPaginationButtonClassName}
          onClick={() => onPageChange(1)}
          disabled={page <= 1}
          aria-label={t('GO_TO_FIRST_PAGE') || 'Go to first page'}
        >
          <FastArrowLeft width={16} height={16} strokeWidth={1.75} />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={toolsPaginationButtonClassName}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          aria-label={t('GO_TO_PREVIOUS_PAGE') || 'Go to previous page'}
        >
          <NavArrowLeft width={16} height={16} strokeWidth={1.75} />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={toolsPaginationButtonClassName}
          onClick={() => onPageChange(Math.min(pageCount, page + 1))}
          disabled={page >= pageCount}
          aria-label={t('GO_TO_NEXT_PAGE') || 'Go to next page'}
        >
          <NavArrowRight width={16} height={16} strokeWidth={1.75} />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={toolsPaginationButtonClassName}
          onClick={() => onPageChange(pageCount)}
          disabled={page >= pageCount}
          aria-label={t('GO_TO_LAST_PAGE') || 'Go to last page'}
        >
          <FastArrowRight width={16} height={16} strokeWidth={1.75} />
        </Button>
      </div>
    </div>
  );
}
